<template>
    <div>
        <div class="row">
            <div class="col-md-6">
<!--                TODO -- hard-coded producer -->
                <contact-card :user="currentUser.user_types.producer"
                              :business="currentUser.user_types.business" type="producer"></contact-card>
            </div>
            <div class="col-md-6">
                <b-form>
                    <b-form-group id="input-group-1" label="Current Password:" label-for="input-1">
                        <b-form-input id="input-1" required type="password" v-model="current"/>
                    </b-form-group>
                    <b-form-group id="input-group-2" label="New Password:" label-for="input-2">
                        <b-form-input id="input-2" required type="password" v-model="updated"/>
                    </b-form-group>

                    <b-form-group id="input-group-3" label="Verify Password:" label-for="input-3">
                        <b-form-input id="input-3" required type="password" v-model="verify"/>
                    </b-form-group>
                    <b-alert show v-show="changeError" variant="warning">{{changeError}}</b-alert>
                    <b-button @click="doChangePassword" variant="primary">Save</b-button>
                </b-form>
            </div>
        </div>
    </div>
</template>

<script>
    import ContactCard from '../../../components/Dashboard/ContactCard'
    import { mapGetters, mapActions } from 'vuex'

    export default {
        name: 'Password',
        components: {ContactCard},
        data () {
            return {
                current: null,
                updated: null,
                verify: null,
                changeError: false
            }
        },
        computed: {
            ...mapGetters(['currentUser']),
        },
        methods: {
            ...mapActions(['changePassword']),
            doChangePassword () {
                console.log('doChangePassword', {
                    username: this.currentUser.email,
                    password: this.current,
                    updated: this.updated,
                    verify: this.verify
                });
                this.changeError = false
                if (this.updated !== this.verify) {
                    this.changeError = 'Passwords do not match.'
                } else if (!this.updated || this.updated === '') {
                    this.changeError = 'Password cannot be blank.'
                } else {
                    this.changePassword({
                        username: this.currentUser.email,
                        password: this.current,
                        updated: this.updated,
                        verify: this.verify
                    }).then(response => {
                        if (response.msg === 'ok') {
                            // TODO this shouldn't be hard-coded to go to producer
                            this.$router.push('/dashboard/producer');
                        } else {
                            this.changeError = response.msg
                        }
                    }, err => {
                        this.changeError = err.response.data.msg
                    })
                }
            }
        }
    }
</script>

<style scoped>

</style>
